export default __webpack_public_path__ + "static/media/PutOnCupSM.2c587900.mp4";